/* Dulcora — sopra il widget Judge.me v3 ("revamp", classi jm-*):
   1. il pulsante "Scrivi una recensione" sale nella colonna sinistra della testata
   2. la griglia foto clienti sale nella colonna destra, con conteggio e "vedi tutte"
   3. le foto vengono richieste grandi: Judge.me le serve a 160 px con un srcset che
      dichiara 200w, e noi le mostriamo fino a 460, quindi sgranavano. Si riscrive
      ?width= e si toglie il srcset, altrimenti il browser continua a scegliere il piccolo.
   4. le recensioni in altra lingua finiscono nella lista principale, in ordine di data
   5. le risposte Dulcora: sulle recensioni a 5 stelle stanno chiuse dietro la riga
      "Dulcora ha risposto · Leggi", sulle altre restano aperte con l'anteprima.
      L'anteprima la fa il CSS (line-clamp), NON si riscrive il testo: il widget si
      ridisegna da solo e la vecchia versione, che teneva il testo pieno in una
      variabile, finiva per mostrare l'anteprima col pulsante "Chiudi".
   6. un solo paginatore: Judge.me ne stampa due (lingua principale e altre lingue),
      il secondo viene nascosto e pilotato dal primo.
   7. pillole paese, quando Judge.me espone la provenienza del recensore (oggi spenta)
   8. l'etichetta del menu d'ordinamento tradotta (vedi sotto)
   Nessuna dipendenza. Si riapplica a ogni ricarica del widget (Judge.me ripagina via AJAX).

   24/09/2026 — aggiunte olandese e tedesco: il negozio serve anche /nl e /de.
   La lingua si legge dall'attributo lang della pagina; se manca una lingua si torna
   all'italiano.

   24/09/2026 — "Sort reviews by". E' l'unica stringa che Judge.me non traduce in
   nessuna lingua, italiano compreso. Non e' visibile: sta in un <label> con classe
   jdgm-visually-hidden, largo 1px e ritagliato, e serve solo a chi naviga con un
   lettore di schermo. Nel pannello dell'app non c'e' un campo per cambiarla, quindi
   la riscriviamo qui. Non cambia niente a video. */
(function () {
  var RADICE = '.dulcora-reviews';
  var in_corso = false;

  var etichette = {
    it: { apri: 'Leggi tutta →', chiudi: 'Chiudi', riga: 'Dulcora ha risposto · Leggi →', intestazione: 'Risposta di Alessio — Dulcora', foto: 'foto', ordina: 'Ordina le recensioni per' },
    en: { apri: 'Read it all →', chiudi: 'Close', riga: 'Dulcora replied · Read →', intestazione: 'Reply from Alessio — Dulcora', foto: 'photos', ordina: 'Sort reviews by' },
    fr: { apri: 'Tout lire →', chiudi: 'Fermer', riga: 'Dulcora a répondu · Lire →', intestazione: 'Réponse d’Alessio — Dulcora', foto: 'photos', ordina: 'Trier les avis par' },
    nl: { apri: 'Lees alles →', chiudi: 'Sluiten', riga: 'Dulcora reageerde · Lees →', intestazione: 'Antwoord van Alessio — Dulcora', foto: 'foto’s', ordina: 'Sorteer beoordelingen op' },
    de: { apri: 'Ganz lesen →', chiudi: 'Schließen', riga: 'Dulcora hat geantwortet · Lesen →', intestazione: 'Antwort von Alessio — Dulcora', foto: 'Fotos', ordina: 'Bewertungen sortieren nach' }
  };
  var lingua = (document.documentElement.lang || 'it').slice(0, 2);
  var voci = etichette[lingua] || etichette.it;

  /* Judge.me serve miniature da 160 px: qui chiediamo la misura che serve davvero. */
  function nitida(img, largo) {
    if (!img || img.dataset.dlLargo === String(largo)) return;
    var src = img.getAttribute('src') || '';
    if (src.indexOf('width=') > -1) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', src.replace(/width=\d+/g, 'width=' + largo));
      img.dataset.dlLargo = String(largo);
    }
  }

  function sposta(radice, sorgente, destinazione) {
    var nodo = radice.querySelector(sorgente);
    var slot = radice.querySelector(destinazione);
    if (!nodo || !slot || slot.contains(nodo)) return false;
    slot.appendChild(nodo);
    return true;
  }

  /* L'etichetta del menu d'ordinamento: invisibile, la leggono solo i lettori di
     schermo. Si riscrive solo se serve, se no il nostro stesso cambio rimetterebbe in
     moto l'osservatore. */
  function ordinamento(radice) {
    radice.querySelectorAll('.jm-sort-filter label, .jm-sort-filter__label').forEach(function (l) {
      if (l.textContent.trim() !== voci.ordina) l.textContent = voci.ordina;
    });
  }

  function galleria(radice) {
    var slot = radice.querySelector('.dl-gallery-slot');
    if (!slot) return;
    var caselle = slot.querySelectorAll('.jm-media-grid__item');
    caselle.forEach(function (c, i) { nitida(c.querySelector('img'), i === 0 ? 1600 : 800); });

    var n = radice.querySelector('.dl-gallery-n');
    var link = radice.querySelector('.dl-gallery-all');
    if (n) n.textContent = caselle.length ? ' — ' + caselle.length + ' ' + voci.foto : '';
    if (link) {
      link.style.display = caselle.length ? '' : 'none';
      if (!link.dataset.dlPronta) {
        link.dataset.dlPronta = '1';
        link.addEventListener('click', function () {
          var prima = slot.querySelector('.jm-media-grid__item');
          if (prima) prima.click();
        });
      }
    }
    radice.classList.toggle('dl-con-galleria', caselle.length > 0);
  }

  function foto_recensioni(radice) {
    radice.querySelectorAll('.jm-review-item .jm-media-thumbnail-list__thumbnail img').forEach(function (img) {
      nitida(img, 600);
    });
  }

  function data_di(rev) {
    var c = rev.querySelectorAll('.jm-reviewer-info__details > .jm-cluster');
    var t = c.length ? c[c.length - 1].textContent.trim() : '';
    var m = t.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    return m ? new Date(+m[3], +m[2] - 1, +m[1]).getTime() : 0;
  }

  function voto_di(rev) {
    var s = rev.querySelector('.jm-star-rating');
    var lab = s && (s.getAttribute('aria-label') || s.textContent) || '';
    var m = lab.match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function mischia(radice) {
    var lista = radice.querySelector('.jdgm-review-list');
    if (!lista) return;

    var altre = radice.querySelector('.jm-other-languages-section');
    if (altre) {
      var testo = altre.querySelector('.jm-other-languages-section__heading');
      if (testo) testo.style.display = 'none';
      altre.querySelectorAll('.jm-review-item').forEach(function (v) { lista.appendChild(v); });
    }

    var righe = Array.prototype.slice.call(lista.querySelectorAll('.jm-review-item'));
    if (righe.length < 2) return;
    var ordinate = righe.slice().sort(function (a, b) { return data_di(b) - data_di(a); });
    var gia_cosi = ordinate.every(function (el, i) { return el === righe[i]; });
    if (gia_cosi) return;
    ordinate.forEach(function (el) { lista.appendChild(el); });
  }

  /* Judge.me stampa due paginatori: quello della lingua principale e quello delle altre
     lingue. Ne teniamo uno solo a video e gli facciamo guidare anche l'altro. */
  function paginatori(radice) {
    var altre = radice.querySelector('.jm-other-languages-section .jm-pagination-controls');
    var prima = radice.querySelector('.jm-primary-language-pagination');
    if (altre) altre.style.display = 'none';
    if (!prima || !altre || prima.dataset.dlPronta) return;
    prima.dataset.dlPronta = '1';
    prima.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.jm-pagination-controls__button--page');
      if (!b) return;
      var n = (b.textContent || '').trim();
      var gemelli = altre.querySelectorAll('.jm-pagination-controls__button--page');
      for (var i = 0; i < gemelli.length; i++) {
        var g = gemelli[i];
        if ((g.textContent || '').trim() === n && g.className.indexOf('--active') === -1) { g.click(); break; }
      }
    }, true);
  }

  function provenienza(rev) {
    var el = rev.querySelector('.jm-reviewer-info__location, .jdgm-rev__location, [class*="reviewer-location"]');
    return el && el.textContent.trim();
  }

  function filtra(radice, paese) {
    radice.querySelectorAll('.jm-review-item').forEach(function (rev) {
      rev.style.display = (!paese || provenienza(rev) === paese) ? '' : 'none';
    });
  }

  function pillole(radice) {
    var vecchia = radice.querySelector('.dl-countries');
    if (vecchia) vecchia.remove();

    var conteggi = {};
    radice.querySelectorAll('.jm-review-item').forEach(function (rev) {
      var nome = provenienza(rev);
      if (!nome) return;
      conteggi[nome] = (conteggi[nome] || 0) + 1;
    });
    var nomi = Object.keys(conteggi);
    if (nomi.length < 2) return;

    var barra = document.createElement('div');
    barra.className = 'dl-countries';
    nomi.sort(function (a, b) { return conteggi[b] - conteggi[a]; }).forEach(function (nome) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dl-country dl-mono';
      b.setAttribute('aria-pressed', 'false');
      b.dataset.paese = nome;
      b.innerHTML = '<span class="dl-country__name"></span><span class="dl-country__n"></span>';
      b.firstChild.textContent = nome;
      b.lastChild.textContent = conteggi[nome];
      b.addEventListener('click', function () {
        var attivo = b.getAttribute('aria-pressed') === 'true';
        barra.querySelectorAll('.dl-country').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', attivo ? 'false' : 'true');
        filtra(radice, attivo ? null : nome);
      });
      barra.appendChild(b);
    });

    var lista = radice.querySelector('.jdgm-review-list, .jm-review-widget__body');
    if (lista) lista.parentNode.insertBefore(barra, lista);
  }

  /* Stato tenuto nelle classi dell'elemento, non in variabili: cosi' un ridisegno del
     widget al massimo riporta la risposta chiusa, non la lascia a meta'. */
  function risposte(radice) {
    radice.querySelectorAll('.jm-shop-reply').forEach(function (rep) {
      var corpo = rep.querySelector('.jm-shop-reply__text');
      if (!corpo || !corpo.textContent.trim()) return;

      var autore = rep.querySelector('.jm-shop-reply__author');
      if (autore) autore.style.display = 'none';
      var altro = rep.querySelector('.jm-shop-reply__expand-button');
      if (altro) altro.style.display = 'none';
      corpo.classList.remove('jm-shop-reply__text--clickable');

      if (rep.dataset.dlPronta) return;
      rep.dataset.dlPronta = '1';
      rep.classList.add('dl-risposta', 'dl-chiusa');

      var piu = document.createElement('span');
      piu.className = 'dl-reply-toggle__more dl-mono';
      piu.textContent = voci.apri;

      var testata = document.createElement('button');
      testata.type = 'button';
      testata.className = 'dl-reply-toggle';
      var titolo = document.createElement('span');
      titolo.className = 'dl-reply-toggle__label dl-mono';
      titolo.textContent = voci.intestazione;
      testata.appendChild(titolo);
      testata.appendChild(piu);
      rep.insertBefore(testata, rep.firstChild);

      testata.addEventListener('click', function () {
        var chiusa = rep.classList.toggle('dl-chiusa');
        piu.textContent = chiusa ? voci.apri : voci.chiudi;
      });

      /* cinque stelle: la risposta sta dietro la riga discreta */
      var rev = rep.closest('.jm-review-item');
      if (rev && voto_di(rev) >= 5) {
        rep.classList.add('dl-nascosta');
        var riga = document.createElement('button');
        riga.type = 'button';
        riga.className = 'dl-reply-line';
        riga.innerHTML = '<span class="dl-reply-line__mark">D</span><span class="dl-mono dl-reply-line__text"></span>';
        riga.lastChild.textContent = voci.riga;
        riga.addEventListener('click', function () {
          riga.remove();
          rep.classList.remove('dl-nascosta', 'dl-chiusa');
          piu.textContent = voci.chiudi;
        });
        rep.parentNode.insertBefore(riga, rep);
      }
    });
  }

  function giro() {
    if (in_corso) return;
    in_corso = true;
    try {
      document.querySelectorAll(RADICE).forEach(function (radice) {
        sposta(radice, '.jm-action-buttons', '.dl-cta-slot');
        sposta(radice, '.jm-media-preview', '.dl-gallery-slot');
        galleria(radice);
        ordinamento(radice);
        if (radice.querySelector('.jm-review-item')) {
          mischia(radice);
          foto_recensioni(radice);
          pillole(radice);
          risposte(radice);
          paginatori(radice);
        }
      });
    } finally {
      in_corso = false;
    }
  }

  document.addEventListener('DOMContentLoaded', giro);
  document.addEventListener('jdgm.reviewWidgetLoaded', giro);
  var attesa = null;
  var osserva = new MutationObserver(function () {
    clearTimeout(attesa);
    attesa = setTimeout(giro, 120);
  });
  document.querySelectorAll(RADICE).forEach(function (r) { osserva.observe(r, { childList: true, subtree: true }); });
  giro();
})();
